import { useTranslation } from 'react-i18next'
import { useTodayAttendance } from '@/hooks/learner/useTodayAttendance'

/**
 * 마이페이지 상단 상태 안내 배너 (축5C 소프트 게이팅 — spec 2026-06-12 §3.7).
 * 휴원: 기간 표시 / 퇴원(잔존 세션): 문의 안내. 재원/대기는 렌더 없음.
 */
export function LearnerStatusBanner() {
  const { t } = useTranslation('learner')
  const { data } = useTodayAttendance()
  if (!data) return null

  if (data.enrollmentStatus === 'ON_LEAVE') {
    const period = data.leaveStart
      ? data.leaveEnd
        ? `${data.leaveStart} ~ ${data.leaveEnd}`
        : `${data.leaveStart} ~`
      : null
    return (
      <div role="status" className="rounded-xl bg-lc-orange-100 text-lc-orange-900 px-4 py-3 text-sm font-medium">
        {period
          ? t('profile.statusBanner.onLeavePeriod', { period })
          : t('profile.statusBanner.onLeave')}
      </div>
    )
  }

  if (data.enrollmentStatus === 'WITHDRAWN') {
    return (
      <div role="status" className="rounded-xl bg-lc-gray-100 text-lc-gray-700 px-4 py-3 text-sm font-medium">
        {t('profile.statusBanner.withdrawn')}
      </div>
    )
  }

  return null
}
